import React from 'react';
import { FaGithub, FaInstagram, FaLinkedin, FaTwitter, FaTwitterSquare } from 'react-icons/fa';
import { Mail, Calendar, ExternalLink, Sun, Moon, Download, ChevronDown, ChevronUp } from 'lucide-react';
import { reactLocalStorage } from 'reactjs-localstorage';
import LazyLoad from 'react-lazy-load';
import '../../css/style.css';

export default function LandingPage() {
  const [isVisible, setIsVisible] = React.useState(false);
  const [theme, setTheme] = React.useState(reactLocalStorage.get('thmem')?reactLocalStorage.get('thmem'):'dark');
  const [dataSource, setdataSource] = React.useState([]);
   const [visibleSections, setVisibleSections] = React.useState(new Set());

    
   React.useEffect(()=>{
    if(reactLocalStorage.get('theme')){
       setTheme(reactLocalStorage.get('theme'))
       if(reactLocalStorage.get('theme') == "dark"){
       document.body.style.backgroundColor = "black";
       document.body.style.color = "white";
       }else{
      document.body.style.backgroundColor = "white";
      document.body.style.color = "black";
       }
    }else{
      reactLocalStorage.set('theme','dark')
       setTheme('dark')
       document.body.style.backgroundColor = "black";
       document.body.style.color = "white";
    }

    /*fetch('https://developerscope.com/api/ProfilePortfolioStartupDataUniq?id=roberto')
    .then(res=>res.json())
    .then(response=>{
      if(response.length == 0)return
      setdataSource(response)
    })*/
   },[])

    const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    reactLocalStorage.set('theme', newTheme);
    setTheme(newTheme);
  };
   
  React.useEffect(()=>{

    setdataSource(projects)

  },[])

   React.useEffect(() => {
    setIsVisible(true);
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleSections(prev => new Set([...prev, entry.target.id]));
            
            // Remove data-animate attribute and transition classes after animation completes
            setTimeout(() => {
              entry.target.removeAttribute('data-animate');
              // Remove transition classes
              entry.target.classList.remove('transition-all', 'duration-1000');
              
              // For project cards, also remove transitions from child elements
              if (entry.target.id === 'projects') {
                const projectCards = entry.target.querySelectorAll('.group');
                projectCards.forEach(card => {
                  card.classList.remove('transition-all', 'duration-500');
                });
              }
              
              // For skills cards
              if (entry.target.id === 'skills') {
                const skillCards = entry.target.querySelectorAll('.group');
                skillCards.forEach(card => {
                  card.classList.remove('transition-all', 'duration-500');
                });
              }
            }, 1000); // Wait for animation to complete
            
            // Stop observing this element
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '50px' }
    );

    const sections = document.querySelectorAll('[data-animate]');
    sections.forEach(section => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  const projects = [
  {
    title: "Dev Workflow Builder",
    image: "https://roberto.developerscope.com/assets/ui.png",
    link: "https://workflow.2kai-agent.com/",
    github: "https://github.com/berto6544-collab/2kai-workflow",
    desc: "Built a no-code workflow automation tool inspired by n8n, with a modular drag-and-drop interface to create and run tasks visually. Emphasized a clean UI/UX using Tailwind CSS and React for performance and usability. Designed to automate tasks like lead scraping & data enrichment.",
    role: "Full-Stack Developer",
    stack: "React.js, Node.js, PostgreSQL, OpenAI, BrightData API, PHP, Docker, REST API",
    timeframe: "July 2025 – current",
    isProblemOpen:false,
    isSolutionOpen:false,
    isOutcomeOpen:false,
    problem: "Manual workflows and lead generation processes are time-consuming and fragmented, leading to inefficiencies and bottlenecks in sales pipelines.",
    solution: "2Kai Workflow Builder allows users to create automated workflows with nodes like triggers, HTTP requests, and logic conditions. It empowers users to automate lead generation, qualify prospects using AI, and visualize data through intuitive dashboards all with no code required.",
    outcome: "Enabled non-technical users to automate 80% of lead generation and data workflows, reducing manual data handling by over 70% across internal teams."
  },
  {
      "title": "Sora 2 Generator",
      "image": "https://sora2.croudhive.com/upload/sora2UI.png",
      "link": "https://sora2.croudhive.com",
      "github": "https://github.com/berto6544-collab/sora-2-generator",
      "desc": "A browser-based tool for creating short, high-quality AI-generated videos optimized for TikTok, YouTube Shorts, and Instagram Reels. Built with a focus on speed, ease-of-use, and seamless API integration using user-provided OpenAI keys.",
      "role": "Full-Stack Developer",
      "stack": "React.js, Node.js, OpenAI Sora 2, Tailwind CSS, TypeScript, Vite",
      "timeframe": "Nov 2025 – Current",
      "isProblemOpen": false,
      "isSolutionOpen": false,
      "isOutcomeOpen": false,
      "problem": "Creating short AI videos is often restricted by region, requires sign-ups, or has usage limits, slowing down iteration and content creation.",
      "solution": "Sora 2 Generator lets users generate, iterate, and export videos directly in the browser using their own OpenAI API key, removing installation, signup, and regional restrictions.",
      "outcome": "Enabled creators to rapidly produce AI videos with full control over their API usage, supporting optimized content for social media platforms."
    },
  {
    title: "MyMiix",
    image: "https://is4-ssl.mzstatic.com/image/thumb/Purple122/v4/8c/92/29/8c92293b-b329-7856-bf9a-2a2f81f8ecfc/a2b1805d-b175-43a1-8259-b3a7a483949d_Simulator_Screen_Shot_-_iPhone_8_plus_1.jpg/750x750bb.jpeg",
    link: "https://mymiix.com",
    desc: "I built MyMiix as a personal media streaming platform that allows users to upload, organize, and stream their own content music, videos, and podcasts in one place. The goal was to create a YouTube Spotify hybrid for personal use, without algorithms or ads interrupting the experience.",
    role: "Full-Stack Developer & UI/UX Designer",
    stack: "React.js, React Native, Node.js, PHP, MySQL, Vanilla CSS, REST API",
    timeframe: "Feb 2020 – 2025",
    isProblemOpen:false,
    isSolutionOpen:false,
    isOutcomeOpen:false,
    github: "https://github.com/berto6544-collab/mimiix-app",
    problem: "Users wanted more control over their personal media libraries without relying on third-party algorithms or data tracking.",
    solution: "MyMiix gives users a private space to store and stream their own music, videos, or audio content. It supports custom playlists, metadata tagging, and mobile-friendly streaming all wrapped in a sleek, distraction-free UI.",
    outcome: "Built a cross-platform ecosystem with thousands of active personal users and seamless media syncing between web and mobile clients."
  },
  {
    title: "HostnPlay",
    image: "https://roberto.developerscope.com/assets/hostnplay-min.webp",
    link: "https://hostnplay.com",
    desc: "I designed and developed HostnPlay, a real-time platform that lets gamers host and monetize private multiplayer game sessions. Inspired by how difficult it is for everyday gamers to earn from their passion, I built HostnPlay as an 'Airbnb for game nights,' where users can schedule sessions, charge for bookings, and manage players seamlessly.",
    role: "Full-Stack Developer & UI/UX Designer",
    stack: "React.js, Node.js, PHP, REST API, MySQL",
    timeframe: "Jun 2023 – Current",
    isProblemOpen:false,
    isSolutionOpen:false,
    isOutcomeOpen:false,
    problem: "Gamers needed an easy way to host and join multiplayer games.",
    solution: "HostnPlay offers a scalable real-time platform designed for gamers to easily host and join private multiplayer games. It includes powerful features like host scheduling, player bookings, and built-in monetization making it simple for anyone to turn their game nights into paid sessions without needing a big following or pro skills.",
    outcome: "Achieved 1,000+ hosted sessions within launch month, proving strong demand and scalability for user-hosted gaming events."
  },
  {
    title: "DeveloperScope",
    image: "https://roberto.developerscope.com/assets/developerscope-min.webp",
    link: "https://developerscope.com",
    desc: "I designed a clean, modern UI optimized for productivity and collaboration. Focused on modular components with clear UX flows using Tailwind and custom React components. The design reflects a startup-focused environment, balancing simplicity with flexibility for different user types technical, creative, business, etc.",
    role: "Full-Stack Developer & UI/UX Designer",
    stack: "React.js, Node.js, PostgreSQL, PHP, REST API",
    timeframe: "Feb 2021 – Current",
    isProblemOpen:false,
    isSolutionOpen:false,
    isOutcomeOpen:false,
    problem: "Aspiring founders often struggle to connect with individuals who complement their skills, share their vision, and are ready to commit to a startup venture.",
    solution: "I built DeveloperScope.com to solve a common problem faced by aspiring founders finding the right people to build with. The platform connects developers, designers, marketers, and business minds to form startup teams and build real projects together. It also provides tools to manage tasks, share files, launch products, and monetize work, all in one space.",
    outcome: "Helped over 500 users form collaborative startup teams and manage real projects with integrated communication and file-sharing tools."
  },
  {
    title: "Space - MyMiix",
    image: "https://roberto.developerscope.com/assets/space.jpg",
    link: "https://space.mymiix.com",
    desc: "Space by MyMiix is a creative platform that lets anyone host art contests with real cash prizes. Artists can explore prompts, submit their work, and compete for recognition and rewards while hosts receive unique, high-quality submissions inspired by their ideas.",
    role: "Full-Stack Developer & UI/UX Designer",
    stack: "React.js, React Native, Node.js, PHP, MySQL, Vanilla CSS, REST API",
    timeframe: "Feb 2024 – Current",
    isProblemOpen:false,
    isSolutionOpen:false,
    isOutcomeOpen:false,
    problem: "Artists often struggle to find meaningful ways to showcase their work, earn recognition, or win real rewards. At the same time, brands or hosts looking for unique creative submissions lack an easy way to engage a community of talented artists.",
    solution: "Space by MyMiix connects artists and hosts through cash-prize art contests. Hosts post prompts and prize pools, artists create and submit entries, and the community votes for winners providing a fun, engaging, and rewarding experience for everyone involved.",
    outcome: "Launched a growing creative community of 2,000+ artists, generating hundreds of submissions across themed contests with automated judging and payouts."
  },
  {
    title: "Croudhive",
    image: "https://roberto.developerscope.com/assets/croudhive-min.webp",
    link: "https://croudhive.com",
    desc: "Designed a minimal, modern interface optimized for product visibility and clarity. Emphasized quick publishing and clean visuals using Tailwind CSS and reusable React components. Layouts were optimized for both individual makers and agencies to easily manage multiple listings.",
    role: "Full-Stack Developer & UI/UX Designer",
    stack: "React.js, Node.js, PHP, REST API, MySQL",
    timeframe: "Sep 2023 – Current",
    isProblemOpen:false,
    isSolutionOpen:false,
    isOutcomeOpen:false,
    problem: "Product creators often struggle to gain visibility, grow an audience, and build early traction. Traditional directories (like Product Hunt) focus on exposure but lack built-in tools for affiliate growth, audience building, and direct communication with users.",
    solution: "Croudhive.com solves this by offering a product discovery platform that goes beyond listing. It enables: Affiliate recruitment, email list building, and campaigns directly integrated into product pages.",
    outcome: "Delivered a platform supporting 300+ product listings with integrated marketing tools, boosting average engagement by 40% per listing."
  },
  {
    title: "2Kai Agent",
    image: "https://roberto.developerscope.com/assets/2kai-ui.png",
    link: "https://2kai-agent.com",
    desc: "Designed a clean, utilitarian interface with a focus on ease-of-use for both affiliates and buyers. Used Tailwind CSS and modular React components to ensure fast, responsive performance. The UX was crafted around efficiency minimizing clicks to submit, approve, or buy company data.",
    role: "Full-Stack Developer",
    stack: "React.js, Node.js, PostgreSQL, OpenAI, BrightData API, PHP, Docker, REST API",
    timeframe: "Dec 2022 – Dec 2025",
    isProblemOpen:false,
    isSolutionOpen:false,
    isOutcomeOpen:false,
    problem: "Traditional lead generation methods are often manual, time-consuming, and inefficient, leading to missed opportunities and reduced sales productivity.",
    solution: "2Kai-Agent.com offers AI-Powered Lead Generation with continuous targeting, real-time qualification, and intuitive dashboards for sales teams.",
    outcome: "Increased lead processing speed by 3x and improved qualification accuracy through AI-driven scoring and workflow automation."
  }
];

   const skills = [
    { category: "Frontend", techs: ["React.js", "Next.js", "React Native", "Tailwind", "Bootstrap","Vanila css","Material UI ","Ant Design","Framer Motion","Three.js","Vite","Babel"], icon: "🎨" },
    { category: "Backend", techs: ["Node.js", "PHP", "Express", "RESTful APIs","Supabase","Firebase","GraphQL"], icon: "⚡" },
    { category: "Databases & Tools", techs: ["MySQL", "PostgreSQL", "Git", "Docker","NPM","Yarn"], icon: "🛠️" }
  ];

   const techs = ["React.js","React Native", "Next.js", "Tailwind","Framer Motion","Node.js", "PHP", "Express", "RESTful APIs","MySQL", "PostgreSQL", "Git"];

  return (
    <div className={`font-sans text-gray-900 lg:flex ${theme == "light"?'bg-white text-black':'bg-black text-white'}`}>
      
      {/* Hero Section */}
      <section id={'hero'} data-animate className={`lg:pt-12 py-30 lg:pb-0 pb-6 lg:overflow-y-auto skicky lg:justify-between justify-center flex flex-col items-center top-0  lg:h-screen lg:w-120 ${theme == "light"?'lg:bg-gray-100 text-black':'lg:bg-[#181b1d] text-white'} hide-scrollbar flex flex-col px-6 text-center transition-opacity duration-1000 ${
          visibleSections.has('hero') ? 'opacity-100' : 'opacity-0'
        }`}>
        <div className={'flex flex-col w-full pb-5'}>
       <LazyLoad height={125}>
        <img  src="https://roberto.developerscope.com/assets/bo27g30yskp-min.jpg" alt="Profile" className={`w-27 h-27 mx-auto rounded-full mb-4 transition-opacity duration-1000`} />
         </LazyLoad>
         
         <h1 className={`text-4xl md:text-4xl font-black mb-2 transition-opacity duration-1000 `}>
            Roberto D'Amico
          </h1>
          
          <div className="text-xl md:text-2xl font-bold mb-2 flex items-center justify-center gap-3">
            <span className="animate-bounce">🚀</span>
            <span className={`${theme == "light"?null:'text-[#ecb523]'}`}>
              Fullstack Developer
            </span>
          </div>
            
 <p className="mb-4 text-md max-w-2xl mx-auto text-[17px]">
          Building scalable fullstack web and mobile platforms with React, React Native, Next.js, Node.js, Supabase, Express, PHP, and modern APIs. Based in <b >Melbourne, Australia</b>.
        </p>

            <div className="mt-4 flex justify-center gap-4">
       <div className={`${theme == "light"?'bg-gray-200 text-black':'bg-[#1f2224] text-gray-300'} text-black text-center p-4 px-6 rounded-full flex items-center justify-between gap-3`}>
            <span className={`flex items-center gap-1.5`}>
              <online className={`${theme == "light"?'bg-green-600':'bg-green-400'} p-1 rounded-full`}></online>For Hire
              </span>
              
              
            
            <span className={`${theme == "light"?'text-gray-800':'text-gray-600'}`}>|</span>
            <a 
              href="mailto:berto6544@gmail.com" 
              className={`flex ${theme == "light"?'hover:text-blue-600':'hover:text-[#ecb523]'} items-center gap-2`}
            >
              <Mail size={24} />
              <span>Email</span>
            </a>
            
          </div>
        </div>

       
        
        
        
        </div>
        <div className="lg:flex flex-col hidden w-full justify-center gap-4 text-2xl py-5" >
        <h3 className="text-2xl font-bold">Tech Stack</h3>
            <div className="space-y-2">
                  {techs.map((tech, techIdx) => (
                    <span 
                      key={techIdx}
                      className={`inline-block cursor-pointer ${theme == "light"?'bg-gradient-to-r from-gray-100 to-gray-200 text-gray-700 hover:text-blue-600 text-black hover:shadow-gray-100':'bg-[#1f2224] hover:text-[#ecb523] text-gray-300 hover:shadow-gray-900'}  px-4 py-2 hover:shadow-md  rounded-full text-[16px] font-medium m-1 hover:scale-105 transition-transform duration-300`}
                    >
                      {tech}
                    </span>
                  ))}
                </div>
        
        </div>

        <div className={`flex w-full sticky bottom-0 ${theme == "light"?'lg:bg-gray-100 text-black lg:border-t-1 lg:border-t-gray-300':'lg:bg-[#181b1d] text-white lg:border-t-1 lg:border-t-[#242b2f]'} justify-center gap-4 text-2xl py-5`}>
          <a className={`${theme == "light"?'hover:text-blue-600':'hover:text-[#ecb523]'}`} href="https://github.com/berto6544-collab/" target="_blank" rel="noreferrer"><FaGithub /></a>
          <a className={`${theme == "light"?'hover:text-blue-600':'hover:text-[#ecb523]'}`} href="https://www.linkedin.com/in/roberto-d-amico-b740249a/" target="_blank" rel="noreferrer"><FaLinkedin /></a>
          <a className={`${theme == "light"?'hover:text-blue-600':'hover:text-[#ecb523]'}`} href="https://www.instagram.com/robertodamico511/" target="_blank" rel="noreferrer"><FaInstagram /></a>
          <a className={`${theme == "light"?'hover:text-blue-600':'hover:text-[#ecb523]'}`} href="https://x.com/d_roberto_1" target="_blank" ><FaTwitterSquare fontSize={24} /></a>
          <a className={`${theme == "light"?'hover:text-blue-600':'hover:text-[#ecb523]'} group relative flex items-center gap-2 transition-opacity duration-300`} href="https://roberto.developerscope.com/assets/Roberto-Damico-Fullstack-CV-2025.pdf"  target="_blank" ><Download fontSize={24} /> <span className={`group-hover:block hidden group-hover:opacity-100 opacity-0 `} style={{fontSize:15}}>Download CV</span></a>

        </div>
      </section>

      <div className={'flex flex-col px-2 w-full lg:h-screen lg:overflow-y-auto'} >
      
        <button
      onClick={toggleTheme}
      style={{zIndex:2,position:'absolute',top:10,right:20}}
      className={`flex items-center rounded-full cursor-pointer  relative
                  ${theme === 'light' ? 'bg-gray-100' : 'bg-[#161619]'}`}
    >
      
      <div
        className={`p-2 rounded-full transform transition-transform duration-100
                    flex items-center justify-center
                    ${theme === 'light' ? 'hover:bg-gray-200 bg-gray-100' : 'bg-gray-900 hover:bg-gray-700'}`}
      >
        {theme === 'light' ? (
          <Sun size={20} className="text-gray-900" />
        ) : (
          <Moon size={20} className="text-blue-50" />
        )}
      </div>
    </button>
      
      {/* Projects Section */}
      <section  id={'project'} data-animate className={`py-12 md:px-6 px-2 transition-opacity duration-1000 ${theme == "light"?'bg-white text-black':'bg-black text-white'} ${
          visibleSections.has('hero') ? 'translate-y-0 opacity-100' : 'translate-y-16 opacity-0'
        }`}>
        <h2 className="text-3xl font-bold lg:text-left text-center mb-8">Projects</h2>
        <div className="grid md:grid-cols-2 gap-8">
          {dataSource.map((proj, idx) => (
            <div key={idx} className={`border list ${theme == "light"?'bg-white text-black border-gray-300':'bg-black text-white border-gray-800'} rounded-xl overflow-hidden flex flex-col justify-between flex-1`}>
              <div className="relative z-10 h-full" >
              <div className={'w-full flex group flex-col relative items-center lg:h-[250px] h-[200px]'}>
              <LazyLoad height={250} width={'100%'} offset={20}>
              <img src={proj.image} srcSet={proj.image} style={{objectFit:'cover'}} className={'w-full lg:h-[250px] h-[200px] object-cover'} />
              </LazyLoad>
             
              <a href={proj.link} target={'_blank'} className='group-hover:opacity-100 group-hover:bg-[rgba(0,0,0,0.7)] absolute opacity-0 flex flex-col justify-center w-full h-full items-center transition-opacity duration-300'>
                <span className={`text-2xl flex items-center gap-2 text-white`}><ExternalLink  /> Visit Live Site</span>
                
                </a>
              
              </div>
              
              <div className='p-6 flex-1 flex flex-col justify-between'>
              <div className="flex  items-center justify-between mb-4">
                    <h3 className="text-2xl font-bold">{proj.title}</h3>
                    <div className={`flex items-center gap-2`}>
                    {proj.github && (<a 
                      className={`inline-block ${theme == "light"?'text-black hover:text-blue-600':'text-gray-300 hover:text-[#ecb523] '} px-4 py-2 rounded-full text-sm font-medium m-1 transition-transform duration-300`}
                      href={proj.github}
                      target={'_blank'}
                      ><FaGithub fontSize={20} /></a>)}
                    
                    <a 
                      href={proj.link} 
                      target="_blank" 
                      rel="noreferrer"
                      className={` ${theme == "light"?'hover:text-blue-600':'hover:text-[#ecb523]'} transition-colors duration-300`}
                    >
                      <ExternalLink size={20} />
                    </a>

                    </div>
                    
                  </div>
                  
                  <div className="space-y-3 mb-6">

                    <p className="text-[17px]"><span className="font-semibold ">Role:</span> {proj.role}</p>
                    <p className="text-[17px]"><span className="font-semibold ">Timeframe:</span> {proj.timeframe}</p>
                    
                    <p className="text-[17px]"> {proj.desc}</p>

                    <p className="text-[12px] flex items-center gap-2 w-full" style={{flexWrap:'wrap'}}>{proj.stack.split(',').map((p)=>(<span className={`inline-block cursor-pointer ${theme == "light"?'bg-gradient-to-r from-gray-100 to-gray-200 text-gray-700 text-black hover:shadow-gray-100':'bg-[#1f2224] text-gray-300 hover:text-[#ecb523] hover:shadow-gray-900'} px-4 py-2 hover:shadow-md rounded-full text-[16px] font-medium m-1 hover:scale-105 transition-transform duration-300`}>{p}</span>))}</p>
                   
                    
                    


                  </div>
              
              <div  className="space-y-3 mb-6 p-3 border border-gray-700 hover:border-gray-600 rounded-md">
                        <div onClick={()=>{
                        proj.isProblemOpen = !proj.isProblemOpen;
                        setdataSource([...dataSource])
                       }} className={`w-full flex items-center justify-between cursor-pointer border-b ${proj.isProblemOpen?'border-gray-700 pb-2':'border-transparent'}`}>
                      <b>Problem</b>
                      {!proj.isProblemOpen?<ChevronDown />:<ChevronUp />}
                      </div>


                      {proj.isProblemOpen?<p>{proj.problem}</p>:null}

                    </div>

                    <div  className="space-y-3 mb-6 p-3 border border-gray-700 hover:border-gray-600 rounded-md">
                       <div onClick={()=>{
                        proj.isSolutionOpen = !proj.isSolutionOpen;
                        setdataSource([...dataSource])
                       }} className={`w-full flex items-center justify-between cursor-pointer border-b ${proj.isSolutionOpen?'border-gray-700 pb-2':'border-transparent'}`}>
                      <b>Solution</b>
                      {!proj.isSolutionOpen?<ChevronDown />:<ChevronUp />}
                      </div>
                      {proj.isSolutionOpen?<p>{proj.solution}</p>:null}

                    </div>

                    {/*<div  className="space-y-3 mb-6 p-3 border border-gray-700 hover:border-gray-600 rounded-md">
                      <div onClick={()=>{
                        proj.isOutcomeOpen = !proj.isOutcomeOpen;
                        setdataSource([...dataSource])
                       }} className={`w-full flex items-center justify-between cursor-pointer border-b ${proj.isOutcomeOpen?'border-gray-700 pb-2':'border-transparent'}`}>
                      <b>Outcome</b>
                      {!proj.isOutcomeOpen?<ChevronDown />:<ChevronUp />}
                      </div>
                      {proj.isOutcomeOpen?<p>{proj.outcome}</p>:null}

                    </div>*/}
                   


               {window.innerWidth <= 600?<a 
                      href={proj.link} 
                      target="_blank" 
                      rel="noreferrer"
                      className={` ${theme == "light"?'hover:text-black bg-yellow-500 hover:bg-yellow-400':'hover:text-black bg-yellow-500 hover:bg-yellow-400'} text-black rounded-full p-2 w-full flex flex-col items-center text-center transition-colors duration-300`}
                    >
                      Live Demo
                    </a>:null}
                   

                  </div>

                  
                    </div>
              
            </div>
          ))}
        </div>
      </section>

      {/* About Me */}
      <section 
        id="about"
        data-animate
        className={`py-10 lg:pb-30 pb-20 md:px-6 px-2 ${theme == "light"?'bg-white text-black':'bg-black text-white'} transition-opacity duration-1000 ${
          visibleSections.has('about') ? 'opacity-100' : 'opacity-0'
        }`}
      >
        <div className="w-full mx-auto lg:text-left text-center">
          <h2 className="text-3xl font-bold mb-6">
            About Me
          </h2>
          <div className={`rounded-xl md:p-12 p-6 border ${theme == "light"?'border-gray-300':'border-gray-800'}`}>
            <p className="text-lg leading-relaxed mb-6">
              I'm Roberto D'Amico, a Fullstack Developer based in <b>Melbourne, Australia</b>, with a passion for building real-time, scalable applications. I specialize in modern frontend frameworks like React, React Native, and Next.js, and develop robust, API-driven backends using Node.js, Supabase, or PHP.
            </p>
            <div className="rounded-2xl">
              <p className="text-lg">
                <span className="font-bold">Strengths:</span> 
                <span className=""> Fullstack development, API architecture, scalable backend systems, devops with Docker, and pixel-perfect UI with Tailwind CSS.</span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Skills */}
      <section  className={`py-12 pb-25 lg:hidden md:px-6 px-2 ${theme == "light"?'bg-white text-black':'bg-black text-white'}`}>
        <h2 className="text-2xl font-bold text-center mb-6">Skills & Expertise</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-center">
          {skills.map((skill, idx) => (
              <div 
                key={idx}
                className={`group text-center p-8  rounded-xl cursor-pointer ${theme == "light"?'border border-gray-300 ':'border border-gray-800'} `}
                style={{ transitionDelay: `${idx * 200}ms` }}
              >
                <div className="text-6xl mb-4 group-hover:scale-110 transition-transform duration-300">
                  {skill.icon}
                </div>
                <h4 className="font-bold text-2xl mb-4 ">{skill.category}</h4>
                <div className="space-y-2">
                  {skill.techs.map((tech, techIdx) => (
                    <span 
                      key={techIdx}
                      className={`inline-block ${theme == "light"?'bg-gradient-to-r from-gray-100 to-gray-200 text-gray-700 text-black hover:shadow-gray-100':'bg-[#1f2224] text-gray-300 hover:shadow-gray-900'} px-4 py-2 hover:shadow-md rounded-full text-[16px] font-medium m-1 hover:scale-105 transition-transform duration-300`}
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            ))}
        </div>
      </section>

      {/* Contact */}
      {/*<section className="bg-gray-100 lg:hidden lg:bg-white py-12 px-6 text-center">
        <h2 className="text-2xl font-bold mb-4">Let’s Connect</h2>
      <div className="flex  flex-col sm:flex-row gap-6 justify-center items-center">
            <a 
              href="mailto:berto_654@hotmail.com.au" 
              className="bg-white text-black px-8 py-4 rounded-full font-semibold hover:scale-105 transition-opacity duration-300 shadow-lg flex items-center gap-3 text-lg"
            >
              <Mail size={24} />
              Send Email
            </a>
            <a 
              href="https://calendly.com/berto65444/30min" 
              className="bg-black text-white px-8 py-4 rounded-full font-semibold hover:bg-white hover:text-black transition-color duration-400 flex items-center gap-3 text-lg"
            >
              <Calendar size={24} />
              Schedule
            </a>
          </div>
      

      
      </section>*/}
      

    
            <a 
              href="https://calendly.com/berto65444/30min" 
              target={'_blank'}
              className={`${theme == "light"?'bg-black text-white hover:bg-white hover:text-black hover:border-1 hover:border-gray-300':'bg-white text-black hover:bg-black hover:text-[#ecb523] hover:border-1 hover:border-gray-800'} text-center fixed hover:shadow-lg bottom-5 right-5 p-4 rounded-full font-semibold  flex justify-center items-center text-lg`}
            >
              <Calendar size={24} />
              
            </a>


      </div>



       <style jsx>{`
        @keyframes gradient-x {
          0%, 100% { background-size: 200% 200%; background-position: left center; }
          50% { background-size: 200% 200%; background-position: right center; }
        }
        .animate-gradient-x { animation: gradient-x 3s ease infinite; }
        .animation-delay-2000 { animation-delay: 2s; }
        .animation-delay-4000 { animation-delay: 4s; }
      `}</style>
    </div>
  );
}
